// import { FC, useMemo } from 'react'
// import { ID, KTSVG } from '../../../../../../../_metronic/helpers'
// import { useListView } from '../../core/ListViewProvider'
// import { useMutation, useQueryClient } from 'react-query'
// import { deleteUser, updateUser, createUser } from '../../core/_requests'
// import { useQueryRequest } from '../../core/QueryRequestProvider'
// import { KTIcon, QUERIES } from '../../../../../../../_metronic/helpers'
// import { useQueryResponse } from '../../core/QueryResponseProvider'
// import { successToast } from '../../../../../../../_metronic/helpers/components/Toaster'
// import { useLocation } from 'react-router-dom'

// const UserConfirmationDelete = ({ id, data, close }: any) => {
//   console.log({ data })
//   const queryClient = useQueryClient()
//   const { query } = useQueryResponse()
//   const { pathname } = useLocation()
//   console.log({ pathname, data })
//   const isWeightScale = pathname.includes('weight-scale')
//   const isAuditor = pathname.includes('auditor')
//   const isCertifications = pathname.includes('certifications')
//   const isProductTesting = pathname.includes('product-testing')


//   // Add this condition for content pages
//   const isContent = pathname.includes('/apps/settings/content')

//   const values = data
//   const payload = isProductTesting
//     ? {
//       // userType: isCertifications ? '' : isAuditor ? 'AUDITOR' : 'PICKUP_POINT_STAFF',
//       // customerType: 'CORPORATE',
//       status: 'INACTIVE',
//     }



//     : isContent
//       ? {
//         ...data,
//         url: data.url || data.videoUrl || data.bannerUrl || 'placeholder-url', // Ensure url comes after spread
//         status: 'INACTIVE',
//       }



//       : pathname.includes('weight-scale')
//         ? {
//           // id: values.id,
//           make: values.make,
//           model: values.model,
//           productSerialNo: values.productSerialNo,
//           capacity: values.capacity,
//           yearOfPurchase: values.yearOfPurchase,
//           scannedImage: values.proofEstablishment,
//           calibratedOn: new Date(values.calibratedOn).getTime(),
//           nextDue: new Date(values.nextDue).getTime(),
//           calibrationCertificate: 'data:application/pdf;base64,JVBERi0xLjQKJeLjz9M...',
//           status: 'INACTIVE',
//         }
//         : pathname.includes('/apps/waste-source/waste-collector')
//           ? {
//             identification: values.identification || 'MOBILE_NO',
//             firstName: values?.personalDetails?.name,
//             mobile: values?.personalDetails?.mobile,
//             middleName: '',
//             lastName: '',
//             userType: 'CUSTOMER',
//             customerType: values.customerType,
//             // customerType: 'CORPORATE',
//             // address: values.address,
//             confirm: values.confirm || true,
//             kycDocument: [{ docUrl: values.bussinessImage, docType: 'POI' }],
//             address: {
//               city: '',
//               country: '',
//               latitute: 0,
//               longitute: 0,
//               state: null,
//               street: '',
//               zipCode: '',
//             },
//             title: values.title,
//             dob: values.dob ? new Date(values?.dob).toISOString().split('T')[0] : '',
//             personalDetails: {
//               name: values.name,
//               email: null,
//               mobile: null,
//               profileImage: null,
//             },
//             status: 'INACTIVE',
//           }
//           : {
//             firstName: values?.personalDetails?.name,
//             mobile: values?.personalDetails?.mobile,
//             userType: isCertifications ? '' : isAuditor ? 'AUDITOR' : 'PICKUP_POINT_STAFF',
//             // customerType: 'CORPORATE',
//             email: values?.personalDetails?.email,
//             status: 'INACTIVE',
//             lastName: '',
//             password: '',
//             address: {
//               country: values?.address?.countryCode || '',
//             },
//           }
//   const deleteItem = useMutation(
//     () =>
//       updateUser(
//         payload,
//         isCertifications
//           ? `certification/edit/${data.id}`



//           : isContent
//             ? `content/update/${data.id}`

//             : isProductTesting
//               ? `items/${data?.tests?.[0]?.testId}/update`
//               : isWeightScale
//                 ? `weightscales/${data.id}/update`
//                 : `users/${data.id}/update`
//       ),
//     {
//       // 💡 response of the mutation is passed to onSuccess
//       onSuccess: () => {
//         // ✅ update detail view directly
//         queryClient.invalidateQueries([`${QUERIES.USERS_LIST}-${query}`])
//         successToast(`Deleted`)
//         close()
//       },
//     }
//   )
//   return (
//     <>
//       <div className='modal fade show d-block' role='dialog' tabIndex={-1} aria-modal='true'>
//         <div
//           className={`modal-dialog 
//          mw-650px modal-dialog-centered`}
//         >
//           <div className='modal-content'>
//             <div className='modal-header'>
//               <h5 className='modal-title'>Confirmation</h5>
//               <div
//                 className='btn btn-icon btn-sm btn-active-light-primary ms-2'
//                 data-bs-dismiss='modal'
//                 aria-label='Close'
//                 onClick={close}
//               >
//                 <KTSVG
//                   path='/media/icons/duotune/arrows/arr061.svg'
//                   className='svg-icon svg-icon-2x'
//                 />
//               </div>
//             </div>
//             <div id='kt_modal_add_user' className='modal-body scroll-y mx-5 mx-xl-15 my-7'>
//               <div className='text-center flex justify-center'>
//                 Are you sure you want to delete ?
//               </div>
//               <div style={{ textAlign: 'center' }}>
//                 <br />
//               </div>
//             </div>
//             <div className='modal-footer'>
//               <button
//                 type='reset'
//                 onClick={() => close()}
//                 className='btn btn-light me-3'
//                 data-kt-users-modal-action='cancel'
//               // disabled={formik.isSubmitting || isUserLoading}
//               >
//                 No
//               </button>
//               <button
//                 onClick={async () => {
//                   await deleteItem.mutateAsync()
//                 }}
//                 type='submit'
//                 className='btn btn-danger'
//                 data-kt-users-modal-action='submit'
//                 style={{ backgroundColor: '#333333' }}
//               >
//                 <span className='indicator-label'>Yes</span>
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//       <div className='modal-backdrop fade show'></div>
//     </>
//   )
// }

// export { UserConfirmationDelete }




import { FC, useMemo } from 'react'
import { ID, KTSVG } from '../../../../../../../_metronic/helpers'
import { useListView } from '../../core/ListViewProvider'
import { useMutation, useQueryClient } from 'react-query'
import { deleteUser, updateUser, createUser } from '../../core/_requests'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { KTIcon, QUERIES } from '../../../../../../../_metronic/helpers'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { successToast } from '../../../../../../../_metronic/helpers/components/Toaster'
import { useLocation } from 'react-router-dom'

const UserConfirmationDelete = ({ id, data, close }: any) => {
  console.log({ data })
  const queryClient = useQueryClient()
  const { query } = useQueryResponse()
  const { pathname } = useLocation()
  console.log({ pathname, data })
  const isWeightScale = pathname.includes('weight-scale')
  const isAuditor = pathname.includes('auditor')
  const isCertifications = pathname.includes('certifications')
  const isProductTesting = pathname.includes('product-testing')


  // Add this condition for content pages
  const isContent = pathname.includes('/apps/settings/content')

  const values = data
  const payload = isProductTesting
    ? {
      // userType: isCertifications ? '' : isAuditor ? 'AUDITOR' : 'PICKUP_POINT_STAFF',
      // customerType: 'CORPORATE',
      status: 'INACTIVE',
    }



    : isContent
      ? {
        ...data,
        url: data.url || data.videoUrl || data.bannerUrl || 'placeholder-url', // Ensure url comes after spread
        status: 'INACTIVE',
      }



      : pathname.includes('weight-scale')
        ? {
          // id: values.id,
          make: values.make,
          model: values.model,
          productSerialNo: values.productSerialNo,
          capacity: values.capacity,
          yearOfPurchase: values.yearOfPurchase,
          scannedImage: values.proofEstablishment,
          calibratedOn: new Date(values.calibratedOn).getTime(),
          nextDue: new Date(values.nextDue).getTime(),
          calibrationCertificate: 'data:application/pdf;base64,JVBERi0xLjQKJeLjz9M...',
          status: 'INACTIVE',
        }
        : pathname.includes('/apps/waste-source/waste-collector')
          ? {
            identification: values.identification || 'MOBILE_NO',
            firstName: values?.personalDetails?.name,
            mobile: values?.personalDetails?.mobile,
            middleName: '',
            lastName: '',
            userType: 'CUSTOMER',
            customerType: values.customerType,
            // customerType: 'CORPORATE',
            // address: values.address,
            confirm: values.confirm || true,
            kycDocument: [{ docUrl: values.bussinessImage, docType: 'POI' }],
            address: {
              city: '',
              country: '',
              latitute: 0,
              longitute: 0,
              state: null,
              street: '',
              zipCode: '',
            },
            title: values.title,
            dob: values.dob ? new Date(values?.dob).toISOString().split('T')[0] : '',
            personalDetails: {
              name: values.name,
              email: null,
              mobile: null,
              profileImage: null,
            },
            status: 'INACTIVE',
          }
          : {
            firstName: values?.personalDetails?.name,
            mobile: values?.personalDetails?.mobile,
            userType: isCertifications ? '' : isAuditor ? 'AUDITOR' : 'PICKUP_POINT_STAFF',
            // customerType: 'CORPORATE',
            email: values?.personalDetails?.email,
            status: 'INACTIVE',
            lastName: '',
            password: '',
            address: {
              country: values?.address?.countryCode || '',
            },
          }
  const deleteItem = useMutation(
    () =>
      updateUser(
        payload,
        isCertifications
          ? `certification/edit/${data.id}`



          : isContent
            ? `content/update/${data.id}`

            : isProductTesting
              ? `items/${data?.tests?.[0]?.testId}/update`
              : isWeightScale
                ? `weightscales/${data.id}/update`
                : `users/${data.id}/update`
      ),
    {
      // 💡 response of the mutation is passed to onSuccess
      onSuccess: () => {
        // ✅ update detail view directly
        queryClient.invalidateQueries([`${QUERIES.USERS_LIST}-${query}`])
        successToast(`Deleted`)
        close()
      },
    }
  )
  return (
    <>
      <div className='modal fade show d-block' role='dialog' tabIndex={-1} aria-modal='true'
      >
        <div
          className={`modal-dialog 
         mw-650px modal-dialog-centered`}
         
        >
          <div className='modal-content' style={{ background: "#ffeef3" }}>
            <div className='modal-header'>
              <h5 className='modal-title'>Confirmation</h5>
              <div
                className='btn btn-icon btn-sm btn-active-light-danger ms-2'
                data-bs-dismiss='modal'
                aria-label='Close'
                onClick={close}
              >
                <KTSVG
                  path='/media/icons/duotune/arrows/arr061.svg'
                  className='svg-icon svg-icon-2x'
                />
              </div>
            </div>
            <div id='kt_modal_add_user' className='modal-body scroll-y mx-5 mx-xl-15 my-7'>
              <div className='text-center' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '16px' }}>
                <div style={{
                  width: '80px',
                  height: '80px',
                  borderRadius: '50%',
                  backgroundColor: '#fee2e2',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#f8285a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
                    <line x1="12" y1="9" x2="12" y2="13" />
                    <line x1="12" y1="17" x2="12.01" y2="17" />
                  </svg>
                </div>
                <div>
                  <p style={{ fontSize: '18px', fontWeight: '600', color: '#1e293b', marginBottom: '8px' }}>
                    Alert: Are you sure you want to delete this data?
                  </p>
                  <p style={{ fontSize: '14px', color: '#64748b', lineHeight: '1.6' }}>
                    Once deleted, the information cannot be restored.
                  </p>
                </div>
              </div>
            </div>
            <div className='modal-footer'>
              <button
                type='reset'
                onClick={() => close()}
                className='btn btn-light me-3'
                data-kt-users-modal-action='cancel'
              // disabled={formik.isSubmitting || isUserLoading}
                style={{ backgroundColor: 'lightgray' , color:'black'}}
              >
                No
              </button>
              <button
                onClick={async () => {
                  await deleteItem.mutateAsync()
                }}
                type='submit'
                className='btn btn-danger'
                data-kt-users-modal-action='submit'
                style={{ backgroundColor: '#f8285a' }}
              >
                <span className='indicator-label'>Yes, i want to delete</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className='modal-backdrop fade show'></div>
    </>
  )
}

export { UserConfirmationDelete }
